/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Bulk_Approve_All_TrustInputs */



/**
* | output |
* | --- |
* | "Approve all + trust" |
*
* @param {Chat_Tool_Bulk_Approve_All_TrustInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_bulk_approve_all_trust = /** @type {((inputs?: Chat_Tool_Bulk_Approve_All_TrustInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Bulk_Approve_All_TrustInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle genehmigen + vertrauen")
	return /** @type {LocalizedString} */ ("Approve all + trust")
});